import { render } from "./TransmutedGradeDataTable.vue?vue&type=template&id=976ba316"
import script from "./TransmutedGradeDataTable.vue?vue&type=script&lang=js"
export * from "./TransmutedGradeDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__